//#region ../../node_modules/.pnpm/camelcase@8.0.0/node_modules/camelcase/index.js
var e = /[\p{Lu}]/u, t = /[\p{Ll}]/u, n = /^[\p{Lu}](?![\p{Lu}])/gu, r = /([\p{Alpha}\p{N}_]|$)/u, i = /[_.\- ]+/, a = RegExp("^" + i.source), o = new RegExp(i.source + r.source, "gu"), s = RegExp("\\d+" + r.source, "gu"), c = (n, r, i, a) => {
	let o = !1, s = !1, c = !1, l = !1;
	for (let u = 0; u < n.length; u++) {
		let d = n[u];
		l = u > 2 ? n[u - 3] === "-" : !0, o && e.test(d) ? (n = n.slice(0, u) + "-" + n.slice(u), o = !1, c = s, s = !0, u++) : s && c && t.test(d) && (!l || a) ? (n = n.slice(0, u - 1) + "-" + n.slice(u - 1), c = s, s = !1, o = !0) : (o = r(d) === d && i(d) !== d, c = s, s = i(d) === d && r(d) !== d);
	}
	return n;
}, l = (e, t) => (n.lastIndex = 0, e.replaceAll(n, (e) => t(e))), u = (e, t) => (o.lastIndex = 0, s.lastIndex = 0, e.replaceAll(s, (n, r, i) => ["_", "-"].includes(e.charAt(i + n.length)) ? n : t(n)).replaceAll(o, (e, n) => t(n)));
function d(e, t) {
	if (!(typeof e == "string" || Array.isArray(e))) throw TypeError("Expected the input to be `string | string[]`");
	if (t = {
		pascalCase: !1,
		preserveConsecutiveUppercase: !1,
		...t
	}, e = Array.isArray(e) ? e.map((e) => e.trim()).filter((e) => e.length).join("-") : e.trim(), e.length === 0) return "";
	let n = t.locale === !1 ? (e) => e.toLowerCase() : (e) => e.toLocaleLowerCase(t.locale), r = t.locale === !1 ? (e) => e.toUpperCase() : (e) => e.toLocaleUpperCase(t.locale);
	return e.length === 1 ? i.test(e) ? "" : t.pascalCase ? r(e) : n(e) : (e !== n(e) && (e = c(e, n, r, t.preserveConsecutiveUppercase)), e = e.replace(a, ""), e = t.preserveConsecutiveUppercase ? l(e, n) : n(e), t.pascalCase && (e = r(e.charAt(0)) + e.slice(1)), u(e, r));
}
//#endregion
export { d as default };
